import { useEffect } from 'react';

/**
 * Sets `document.title` when a non-empty title is provided.
 * Leaf pages call this to override the route-level title set by `DocumentTitle`.
 */
export function useDocumentTitle(title: string | undefined) {
	useEffect(() => {
		if (title) {
			document.title = title;
		}
	}, [title]);
}
